import request from '@/utils/request'

// 查询用户报告主记录列表
export function listReportUser(query) {
    return request({
        url: '/biz/reportUser/list',
        method: 'get',
        params: query
    })
}

// 查询用户报告主记录详细
export function getReportUser(id) {
    return request({
        url: '/biz/reportUser/' + id,
        method: 'get'
    })
}

// 新增用户报告主记录
export function addReportUser(data) {
    return request({
        url: '/biz/reportUser',
        method: 'post',
        data: data
    })
}

// 修改用户报告主记录
export function updateReportUser(data) {
    return request({
        url: '/biz/reportUser/update',
        method: 'post',
        data: data
    })
}

// 删除用户报告主记录
export function delReportUser(id) {
    return request({
        url: '/biz/reportUser/delete/' + id,
        method: 'post'
    })
}
